import PropTypes from "prop-types"
import { map, find, size } from "lodash"
import moment from "moment"
import { List, ListItem, ListItemText, ListItemAvatar, Checkbox, ListSubheader } from "@mui/material"
import { RESOURCES_PER_AT_FUND } from "helpers/op-pro"

export default function FundList({ funds, toggleFund, toImport, availableResourceSlots, isOpPro }) {
  const isChecked = (fundId) => Boolean(find(toImport, ({ fundId: fId }) => fId === fundId))
  const noAvailableResources = isOpPro && availableResourceSlots === 0
  return <>
    <ListSubheader component="div" disableGutters>
      Fund list
    </ListSubheader>
    <List>
      {map(funds, (fund) => {
        const { fundId, fundName, modified, portfolio } = fund
        const notEnoughResourcesForFund = isOpPro && (availableResourceSlots - (size(toImport) * RESOURCES_PER_AT_FUND) < RESOURCES_PER_AT_FUND)
        const isDisabled = Boolean(portfolio) || noAvailableResources || (!isChecked(fundId) && notEnoughResourcesForFund)
        return <ListItem disableGutters key={fundId} disabled={isDisabled}>
          <ListItemAvatar>
            <Checkbox disabled={isDisabled} color="primary" checked={isChecked(fundId)} onChange={toggleFund(fund)} />
          </ListItemAvatar>
          <ListItemText primary={`${fundName} + forecast`} secondary={`Last modified ${moment(modified).fromNow()}`} />
        </ListItem>
      })}
    </List>
  </>
}

FundList.propTypes = {
  funds: PropTypes.array.isRequired,
  toggleFund: PropTypes.func.isRequired,
  toImport: PropTypes.array.isRequired,
  availableResourceSlots: PropTypes.number,
  isOpPro: PropTypes.bool.isRequired,
}
